module.exports = __webpack_public_path__ + "static/media/dotanimation.963d8c16.gif";